package diana.soleil.design.iraniancanadienbazzar.core.data

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

/**
 * How many **sponsored slots** may appear in a placement (Home featured carousel, list "Recommended"
 * section). Driven by Remote Config `sponsored_slots_max`, pushed from the composition root (like the
 * launched-cities gate) so feature modules stay decoupled from `:core:firebase`. Feature ViewModels
 * observe [slotsMax] and cap + rank their sponsored set. Lives in `:core:data`.
 */
class SponsorshipConfig {
    private val _slotsMax = MutableStateFlow(DEFAULT_SLOTS_MAX)
    val slotsMax: StateFlow<Int> = _slotsMax.asStateFlow()

    /** Pushed from the composition root after a Remote Config fetch. Negative values are ignored. */
    fun setSlotsMax(max: Int) {
        if (max >= 0) _slotsMax.value = max
    }

    private companion object {
        // Mirrors the Remote Config default so ranking is sane before the first fetch.
        const val DEFAULT_SLOTS_MAX = 3
    }
}
